<template>
    <div class="page">
        <Headers></Headers>
        <div class="banner">
            <!-- 顶部标题 -->
            <div class="pdfPageTitle mg_t">
                <div class="pdfPageTitle-txt">
                    <span class="pdfPageTitle-txt__first">直接减排贡献</span>
                    <span class="pdfPageTitle-txt__second">(权重{{PdftStore.fromData.spaceEmissionDirectReduction?.weight}}%)</span>
                </div>
                <div class="pdfPageTitle-icon">
                    <img src="@/assets/img/page7.png">
                </div>
            </div>

            <!-- 顶部数据 -->
            <div class="top_box">
                <div class="left">
                    <div class="title mg_b">排放数据：</div>
                    <div class="txt">{{PdftStore.fromData.spaceEmissionDirectReduction?.emissionDataStr}}</div>
                    <!-- <div class="tx">数据来源：XXX报告PXX页。</div> -->
                </div>
                <div class="right">
                    <div class="title">数据与参考标准</div>
                    <div class="txt">{{PdftStore.fromData.spaceEmissionDirectReduction?.referenceStandards}}</div>
                </div>
            </div>

            <!-- 明细 -->
            <div class="min_box">
                <div class="title">碳中和运营指数得分明细</div>
                <List :type=3  :id="'listPdfReport3'"/>
            </div>

            <!-- 数据图表 -->
            <div class="banner_box">
                <div class="left_box">
                    <div class="title">直接减排得分：</div>
                    <div class="jindu">
                        <Progess v-if="PdftStore.fromData.spaceEmissionDirectReduction" :name="'page7progess'" :num="PdftStore.fromData.spaceEmissionDirectReduction?.updateScore" :maxNum="'0万吨'" :minNum="'45万吨'" :carbonNum="PdftStore.fromData.spaceEmissionDirectReduction?.emissionDataStr+''" :max='100' :min='30'/>
                    </div>
                </div>
                <div class="right_box">
                    <div class="top_box_banner">
                        <div class="title">评分逻辑</div>
                        <div class="txt">{{PdftStore.fromData.spaceEmissionDirectReduction?.scoreStandard}}</div>
                    </div>
                    <div class="title">碳中和运营指数综合表现</div>
                    <div class="ec_t">
                        <Echarts v-if="PdftStore.fromData.spaceEmissionDirectReduction" :name="'page7echarts'"  :type="'c'"/>
                    </div>
                </div>
            </div>
            <!-- 底部 -->
            <Bottoms/>
            <div class="flxed">05</div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Bottoms from '../components/bottoms.vue'
import Progess from '../components/progess.vue'
import List from '../components/list.vue'
import Echarts from '../components/echarts.vue'
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'page7',
    components:{Headers, Bottoms, List, Progess, Echarts},
    setup() {
        const data = reactive({})
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .banner{
        width: 100%;
        padding: 0 130px;
        .mg_t{
            margin-top: 96px;
        }
        .flxed{
            position: absolute;
            right: 20px;
            bottom: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
        }
        .top_box{
            margin-top: 50px;
            display: flex;
            .title{
                font-size: 28px;
                font-weight: 500;
                color: #333333;
                line-height: 42px;
            }
            .left{
                width: 710px;
                .mg_b{
                    margin-bottom: 20px;
                }
                .txt{
                    font-size: 32px;
                    font-weight: 500;
                    line-height: 36px;
                    color: rgba(0, 186, 244, 1);
                }
                .tx{
                    margin-top: 15px;
                    font-size: 18px;
                    font-weight: 400;
                    color: #666666;
                }
            }
            .right{
                width: calc(100% - 710px);
                padding-left: 40px;
                border-left: 1px solid #C5C5C6;
                .txt{
                    font-size: 16px;
                    font-weight: 400;
                    text-align: justify;
                    color: #333333;
                    line-height: 24px;
                    margin-top: 23px;
                    white-space: normal;
                    word-wrap: break-word;
                }
            }
            
        }
        .min_box{
            margin-top: 55px;
            font-size: 24px;
            font-weight: 500;
            color: #333333;
            line-height: 42px;
            .title{
                margin-bottom: 33px;
            }
        }
    }
}
.banner_box{
    display: flex;
    width: 100%;
    margin-top: 70px;
    .left_box{
        width: 670px;
        height: 100%;
        padding-right: 40px;
        
    }
    .right_box{
        width: calc(100% - 670px);
        height: 100%;
        padding-left: 39px;
        border-left: 1px solid #C5C5C6;
    }
    .top_box_banner{
        height: 350px;
    }
    .title{
        font-size: 28px;
        font-weight: 500;
        color: #333333;
        line-height: 42px;
    }
    .jindu{
        height: calc(880px - 42px);
        width: 100%;
        display: flex;
        align-items: center;
    }
    .mg_top{
        margin-top: 90px;
    }
    .ec_t{
        margin-top: 10px;
        width: 100%;
        height: 413px;
    }
    .txt{
        font-size: 16px;
        font-weight: 400;
        text-align: justify;
        color: #333333;
        line-height: 24px;
        margin-top: 10px;
        white-space: normal;
        word-wrap: break-word;
    }
    .txt_s{
        color: #999999;
    }
}
</style>